<template>
  <div
    layout-align="center center"
    class="mb-6"
  >
    <div class="page-topborder" />

    <div
      v-if="team.id"
      class="page-width pb-3"
    >
      <div
        class="py-3"
      >
        <div
          class="headline font-weight-bold"
          layout="row"
          layout-align="start center"
        >
          <v-icon
            class="ml-2"
            :size="32"
            :color="team.is_enabled ? 'success' : 'error'"
            :title="team.is_enabled ? 'Enabled' : 'Disabled'"
          >
            mdi-circle-outline
          </v-icon>
          <span class="ml-2">{{ team.name }}</span>
        </div>
      </div>
      <router-link
        :to="{name: prevRoute}"
        class="link-unstyled py-2 ml-4 no-printable"
        style="width: max-content"
      >
        <v-icon
          color="primary"
          size="16"
        >
          mdi-arrow-left
        </v-icon>
        Back to the list
      </router-link>
      <div
        layout="row"
        layout-align="start start"
        class="mb-3 no-printable"
        style="background-color: #fff"
      >
        <v-tabs
          class="ml-3 grey"
          flex
        >
          <v-tabs-slider color="#f4b944" />
          <v-tab
            router-link
            :to="{name: 'admin-sessions-teams-show-info', params: {id: team.id}}"
          >
            Information
          </v-tab>
          <v-tab
            router-link
            :to="{name: 'admin-sessions-teams-show-exceptions', params: {id: team.id}}"
          >
            Capacity exceptions
          </v-tab>
        </v-tabs>
        <v-btn
          class="mx-0"
          large
          icon
          @click="toggle"
        >
          <v-icon>{{ team.is_enabled ? 'mdi-lock': 'mdi-lock-open' }}</v-icon>
        </v-btn>
      </div>
      <router-view
        :key="routerViewKey"
        :team.sync="team"
        class="px-3"
      />
    </div>
    <div
      v-else
      layout="row"
      class="ma-5"
      layout-align="center center"
    >
      <v-progress-circular
        indeterminate
        color="primary"
        size="64"
      />
    </div>
  </div>
</template>

<script>
import Auth from "@/plugins/auth"
import Consts from "@/consts"
import GlobalMixin from "@/mixins/global"
import Params from "@/api/params"

export default {
  mixins: [GlobalMixin],
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.name === "admin-sessions-teams-exceptions") {
        vm.prevRoute = from.name.slice(0);
      }
    });
  },
  beforeRouteUpdate(to, from, next) {
    if (from.params.id !== to.params.id) {
      this.fetch(to.params.id); // Prevent tab change
    }
    next();
  },
  data() {
    return {
      loading: false,
      team: {},
      routerViewKey: 1,
      Consts,
      Auth,
      prevRoute: "admin-sessions-teams-index"
    };
  },
  mounted() {
    this.loading = true;
    this.fetch();
  },
  methods: {
    fetch(id = null) {
      Params.get("teams", id ? id : this.$route.params.id).then(res => {
        this.team = res.data;
        this.loading = false;
        this.routerViewKey++;
        this.team = Object.assign({}, this.team);
      });
    },
    toggle() {
      if (this.team.is_enabled) {
        Params.disable("teams", this.team.id).then(() => {
          this.team.is_enabled = 0;
          this.$snotify.success(
            `Team "${this.team.name}" has been disabled`
          );
        });
      } else {
        Params.enable("teams", this.team.id).then(() => {
          this.team.is_enabled = 1;
          this.$snotify.success(
            `Team "${this.team.name}" has been enabled`
          );
        });
      }
    },
  }
};
</script>
<style scoped>
.expo {
  vertical-align: super;
  color: lightgrey;
  font-size: 14px;
}
.edit-icon {
  text-decoration: none;
}

@media print {
  .headline > .v-btn,
  .headline > .v-menu--inline,
  .v-tabs {
    display: none;
  }
  .no-printable {
    display: none;
  }
}
</style>
<style>
@media print {
  .no-printable {
    display: none;
  }
}
</style>
